import {
    Layout,
    AppBar,
    TitlePortal,
} from 'react-admin';
import { Chip, CssBaseline } from '@mui/material';
import { MyMenu } from './AppMenu';

const MyAppBar = (props) => {
    const appBarText = () => {
        if (props.deployment == 'local') {
            return "Local Development"
        }
        if (props.deployment == 'dev') {
            return "Development"
        }
        if (props.deployment == 'stage') {
            return "Staging"
        }
    }

    return (
        <AppBar>
            <TitlePortal />
            {appBarText() && (
                <Chip
                    size="small"
                    color="warning"
                    label={appBarText()}
                    sx={{ mr: 2 }}
                />
            )}
        </AppBar >
    )
};


const MyLayout = ({ children, deployment }) => {
    return (
        <>
            <CssBaseline />
            <Layout
                menu={MyMenu}
                appBar={() => <MyAppBar deployment={deployment} />}
            >
                {children}
            </Layout>
        </>
    )
};

export default MyLayout;
